import { defineMessages } from 'react-intl';

export default defineMessages({
    completingYourPurchaseMessage: {
        id: 'renewal.ea.renewalChangeDiffPage.Completing your purchase...',
        defaultMessage: 'Completing your purchase...'
    },
    loadingPolicyDiff: {
        id: 'renewal.ea.renewalChangeDiffPage.Loading...',
        defaultMessage: 'Loading...'
    },
    changesPhrases: {
        id: 'renewal.ea.policyDiffPage.Change Phrases',
        defaultMessage: 'Change Phrases'
    },
    issue: {
        id: 'renewal.ea.policyDiffPage.Issue',
        defaultMessage: 'Issue'
    },
    bindError: {
        id: 'renewal.ea.config.Unable to bind change',
        defaultMessage: 'Unable to bind change'
    },
    bindErrorMessage: {
        id: 'renewal.ea.config.An error occurred while attempting to bind changes',
        defaultMessage: 'An error occurred while attempting to bind changes'
    },
    changeConflict: {
        id: 'renewal.ea.renewalChangeDiffPage.tab.Change Conflicts',
        defaultMessage: 'Change Conflicts'
    },
    signature: {
        id: 'renewal.ea.renewalChangeDiffPage.tab.Signature',
        defaultMessage: 'Signature'
    },
    differencesTab: {
        id: 'renewal.ea.renewalChangeDiffPage.tab.Differences',
        defaultMessage: 'Differences'
    },
    noDataText: {
        id: 'renewal.ea.policyDiffPage.No Change Phrases',
        defaultMessage: 'No Change Phrases'
    }
});
